import Funnel from "../services/funnel-service.js";
import Mixin from "../mixin.js";
const template = `
    <div class="grid">
        <div class="s12 m10 l8 clm card center">
        	<br>
            <h2 class="text-center">Oops! that page couldn't be found.</h2>
            <p class="text-center">Don't worry we remember your previous page and can take you back with the click of a button!.</p>
            <div class="">
               <button aria-label="Go back to the previous page" class="button medium action fill primary-btn next-step" @click="back()">
               GO BACK
                    <img alt="Arrow icon" class="iconic iconic-sm" data-state="up" data-src="/static/images/iconic/arrow.svg">
                </button>
            </div>
        </div>
    </div>
`;
export default {
    name: 'b-page-not-found',
    template,
	mixins: [Mixin],
	computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        }
    },
    mounted(){

    },
    methods:{
    	back() {
           this.$router.back()
        },
    }
};
